"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Countdown = void 0;
const react_1 = __importStar(require("react"));
const date_fns_1 = require("date-fns");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const tooltip_1 = require("../tooltip/tooltip");
const countdown_styles_1 = require("./countdown-styles");
exports.Countdown = (0, react_1.forwardRef)(function Countdown({ notifyChange, tooltipTitle, After }, ref) {
    const classes = (0, countdown_styles_1.useStyles)();
    const [seconds, setSeconds] = (0, react_1.useState)(0);
    const [targetDate, setTargetDate] = (0, react_1.useState)(new Date());
    (0, react_1.useImperativeHandle)(ref, () => ({
        reset: (date) => {
            setTargetDate(new Date(date));
            setSeconds((0, date_fns_1.differenceInSeconds)(new Date(date), new Date()));
        },
    }));
    (0, react_1.useEffect)(() => {
        const timeout = setInterval(() => {
            const diff = (0, date_fns_1.differenceInSeconds)(targetDate, new Date());
            setSeconds(diff);
            notifyChange === null || notifyChange === void 0 ? void 0 : notifyChange(diff);
        }, 1000);
        return () => clearInterval(timeout);
    }, [targetDate]);
    return (react_1.default.createElement("div", { className: classes.wrapper },
        react_1.default.createElement(tooltip_1.Tooltip, { title: tooltipTitle },
            react_1.default.createElement(Typography_1.default, { className: classes.countdown, variant: "h1" }, `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`)),
        After && react_1.default.createElement(After, null)));
});
//# sourceMappingURL=countdown.js.map